var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { directives: [{ name: "loading", rawName: "v-loading", value: _vm.loading, expression: "loading" }], staticClass: "skin-list" }, [_vm._v("\n  预设皮肤：\n  "), _vm._l(_vm.skinList, function (tag, index) {
    return _c('list-item', { key: tag.id, attrs: { "active": _vm.checkIsActive(tag), "showClose": index > 0 }, on: { "close": function close($event) {
          return _vm.handleClose(tag);
        }, "edit": function edit($event) {
          return _vm.handleEdit(tag);
        }, "click": function click($event) {
          return _vm.handleClick(tag);
        } } }, [_vm._v("\n    " + _vm._s(index + 1) + ": " + _vm._s(tag.name) + "\n  ")]);
  }), _vm._v(" "), _vm.skinList.length < 5 ? _c('el-button', { staticClass: "create-button", attrs: { "size": "mini" }, on: { "click": _vm.handleCreate } }, [_vm._v("添加皮肤")]) : _vm._e()], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };